// authProvider.js
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import serverCredintials from "../../constants/serverCredintials";
const AD_CONFIG = serverCredintials.BuildURL.geAdAuthConfig();

// Msal Configurations
export const msalConfig = {
    auth: {
        authority:
            "https://login.microsoftonline.com/" + AD_CONFIG.TENANT_ID,
        clientId: AD_CONFIG.CLIENT_ID,
        postLogoutRedirectUri: `${AD_CONFIG.redirectURI}`,
        redirectUri: `${AD_CONFIG.redirectURI}`,
        // clientSecret: `${client_secret}`,
        validateAuthority: true,
        // After being redirected to the "redirectUri" page, should user
        // be redirected back to the Url where their login originated from?
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },
};

// Authentication Parameters
export const authenticationParameters = {
    scopes: [`api://${AD_CONFIG.CLIENT_ID}/user_impersonation`], // exposed this api in app registration
};
export const authenticationParametersGraph = {
    scopes: ["User.Read"],
};
// Options
export const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: `${AD_CONFIG.redirectURI}`,
};
export const AuthProvider = new MsalAuthProvider(
    msalConfig,
    authenticationParameters,
    options
);
